// extracted by mini-css-extract-plugin
module.exports = {"root":"TabBar_root__YxboF","item":"TabBar_item__y4b89","rotation":"TabBar_rotation__yGcpW"};